/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import React, { useContext, useEffect, useState, useCallback } from 'react'
import { FormContext } from '../Component/Forms/FormContext';
import { InputLabel } from '@material-ui/core';
import ThemeControls from "../Component/AllThemesControl";
import FormHelperText from '@mui/material/FormHelperText';
import OutlinedInput from '@mui/material/OutlinedInput';
import elementValidation from '../Component/validation.js';
import { MasterContext } from '../services/MasterContext';
import { APIGET } from '../services/APIServices';
import { debounce } from 'lodash';

function formatTablecellValue(value) {

  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number') {
    if (Number.isInteger(value)) {
        return value.toString();
    } else {
        const valueString = value.toString();
        const decimalIndex = valueString.indexOf('.');
        if (decimalIndex !== -1 && valueString.length - decimalIndex - 1 <= 5) {
            return value.toFixed(valueString.length - decimalIndex - 1);
        } else {
            return value.toFixed(2);
        }
    }
  }
  return "";
}

export default function Input(props) {
  const { useStyle } = ThemeControls;
  const classes = useStyle();

  const required = null;
  let { id, field_unique, field_option_src,field_flotFix, field_disabled_Edit, field_type, field_id, field_apipath, field_disabled, field_label, field_placeholder, field_value, field_options, field_helperText, field_minlength, field_maxlength, field_maxvalue, field_value_type, field_minvalue, field_error_msg_required, field_error_msg_minlength, field_error_msg_maxlength, field_error_msg_minvalue, field_error_msg_maxvalue, field_error_msg_uq, field_mandatory } = props;
  const { handleChange } = useContext(FormContext)
  const [fieldDisable, setFieldDisable] = useState(field_disabled);
  const [fieldOptions, setFieldOptions] = React.useState(field_options);
  let { masterData } = React.useContext(MasterContext);
  const elementField = { id, field_unique, field_disabled_Edit, field_type, field_disabled, field_id, field_apipath, field_label, field_placeholder, field_value, field_options, field_helperText, field_minlength, field_maxlength, field_maxvalue, field_value_type, field_minvalue, field_error_msg_required, field_error_msg_minlength, field_error_msg_maxlength, field_error_msg_minvalue, field_error_msg_maxvalue, field_error_msg_uq, field_mandatory };
  const [value, setValue] = React.useState(field_value);
  const [attr, setAttr] = React.useState();
  
  function handleBlur() {
    elementValidation(elementField)
  }
 // Debounce function to delay the API call
 const debounceValidation = useCallback(
  debounce((field) => {
    elementValidation(field); // API validation logic here
  }, 500), [] // 500ms delay
);

  useEffect(() => {
    setValue(formatTablecellValue(field_value))
    if (field_apipath && field_value) {
      debounceValidation(elementField)
    }
  }, [field_apipath, field_value])

  useEffect(() => {
    if (typeof id === 'number' && field_disabled_Edit === 'yes' && field_value) {
      setFieldDisable(true)
    } else {
      setFieldDisable(field_disabled)
    }
  }, [field_disabled, field_value]);

  async function getOptions(props) {

    try {
      if (props.field_option_src_context) {
        if(props.field_option_check_local_storage==="true"&&(masterData[`${props.field_option_src_context}`]&&masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`])){
          const data = masterData[`${props.field_option_src_context}`]&&masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`];
          // setValue(data);
          handleChange(field_id, {}, data)
        }
      else{
        let APIRES = await APIGET(props.field_option_src_context + `/` + props.field_option_src_critieria).then(
          (APIRES) => {
            if (APIRES.data) {
              let data=""
              if (Array.isArray(APIRES.data)) {
              let _obj = new Object();
              if (field_option_src.field_option_attributes) {
                field_option_src.field_option_attributes.map((att) => {
                  _obj[`data_${att}`] = APIRES.data[0][att];
                });
                setAttr(_obj)
              }
               data = formatTablecellValue(APIRES.data[0][props?.field_option_value],field_flotFix)
              // setValue(data);
              handleChange(field_id, {}, data)
            } else if (typeof APIRES.data === 'object') {
              let _obj = new Object();
              if (field_option_src.field_option_attributes) {
                field_option_src.field_option_attributes.map((att) => {
                  _obj[`data_${att}`] = APIRES.data[att];
                });
                setAttr(_obj)
              }
               data = formatTablecellValue(APIRES.data[props?.field_option_value],field_flotFix)
              // setValue(data);
              handleChange(field_id, {}, data)
            }
            if(masterData[`${props.field_option_src_context}`&&`${props.field_option_src_context}`]){
              if(masterData[`${props.field_option_src_context}`]){
                masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`] = data;
              }
              else{
                masterData[`${props.field_option_src_context}`] = {}
                masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`] = data;
              }
            }
            else{
              masterData[`${props.field_option_src_context}`]={}
              masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`] = data;
            }
            }
          }
        );
      }
    }
    } catch (err) {/** TODO Do Nothing */ }
  }
  useEffect(() => {
    if (props?.field_option_src?.field_option_src_critieria && !id) {
      getOptions(field_option_src);
    }
  }, [props?.field_option_src?.field_option_src_critieria])

  // const handleInputChange = (event) => {
  //   const newValue = event.target.value;

  //   // Capture cursor position
  //   const cursorPosition = event.target.selectionStart;

  //   // Update the value
  //   setValue(newValue);
  //   handleChange(field_id, {}, newValue);

  //   // Reposition cursor
  //   setTimeout(() => {
  //     event.target.setSelectionRange(cursorPosition, cursorPosition);
  //   }, 0); // Wait for the next render cycle
  // };

  const handleInputChange = (event) => {
    const newValue = event.target.value;
  
    // Update the value
    setValue(newValue);
    handleChange(field_id, {}, newValue);
  };

  return (
    <div className={props.field_parent_class ? classes[props.field_parent_class] : classes.inputroot} style={props.field_parent_style ? props.field_parent_style : null}>
      <div style={{ display: "flex" }}>
        <InputLabel style={props.field_label_style ? props.field_label_style : null} className={props.field_label_class ? classes[props.field_label_class] : classes.label}  >{field_label}</InputLabel>{field_mandatory === "yes" ? <span
          style={{
            fontSize: "18px",
            color: "#d71729",
            fontWeight: "400",
            lineHeight: "20px",
            transform: "translateY(-2px)"
          }}>*</span> : null}
      </div>
      {/* <FormControl > */}
      <OutlinedInput className={classes.input}
        {...attr}
        id={field_id}
        type={field_type}
        value={value}
        placeholder={field_placeholder ? field_placeholder : ''}
        // onChange={event => handleChange(field_id, {}, event.target.value)}
        onChange={handleInputChange}
        error
        disabled={fieldDisable}
        inputProps={{ min: field_minvalue, max: field_maxvalue, minLength: field_minlength, maxLength: field_maxlength }}
        onBlur={() => (handleBlur())}
      />

      <FormHelperText>{field_helperText || elementField.field_helperText}</FormHelperText>
      {/* </FormControl> */}

    </div>
  );
}
